import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
import { UTM } from "components/atoms/CardBarStats";

export type UTMResponse = {
  data: { data: UTMSessions[] };
  isLoading: boolean;
};
export type UTMSessions = {
  sessionId: string;
  utm?: UTM
  visits: UTMVisits[]
}

export type UTMVisits = {
  dateVisited: string | null
  id: string | null
  pageName: string | null
  timeOnPage: number | null
  url: string | null
}
export const getLeadVisits = createAsyncThunk("lead/visits", async (leadId: string, thunkAPI) => {
  try {
    const response = await axios.get<UTMResponse>(`/pixel/history/lead/visits?lead_id=${leadId}`, { withCredentials: true });
    return thunkAPI.fulfillWithValue(response.data.data);
  } catch (err: any) {
    return thunkAPI.rejectWithValue(err.response.data);
  }
})
const initialState: UTMResponse = {
  data: { data: [] },
  isLoading: false
}
export const leadVisited = createSlice({
  name: "leadVisited",
  initialState,
  reducers: {
    resetLeadVisits: (state) => {
      state.data.data = []
      state.isLoading = false
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getLeadVisits.pending, (state, _action) => {
      state.isLoading = true
    })
    builder.addCase(getLeadVisits.fulfilled, (state, action) => {
      state.data = action.payload
      state.isLoading = false
    })
    builder.addCase(getLeadVisits.rejected, (state, action) => {
      state.data.data = []
      state.isLoading = false
    })
  }
})
